export const enClientPortalLayoutPages = {
    layout: {
        navigation: {
            dashboard: 'Overview',
            inbox: 'Inbox',
            profile: 'Profile',
        },
    },
}
